import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { EGDSButton } from '@egds/react-core/button';
import { EGDSLayoutFlex } from '@egds/react-core/layout-flex';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { LocalizedText } from '@shared-ui/localization-context';
const ButtonTracked = ClickTracker(EGDSButton);
export const CloseFormButton = ({
  onClick
}) => React.createElement(EGDSLayoutFlex, {
  justifyContent: "center"
}, React.createElement(EGDSSpacing, {
  padding: {
    blockend: 'four',
    blockstart: 'four'
  }
}, React.createElement(ButtonTracked, {
  linkName: "Close search form",
  onClick: onClick,
  align: "center",
  className: "uitk-button-tertiary",
  "data-stid": "close-search-form",
  rfrr: ':CloseSearch'
}, React.createElement(LocalizedText, {
  message: "hotels.searchResults.close.text"
}))));